import { useMutation, useQueryClient } from "@tanstack/react-query";
import { IPackagesApi } from "@/api/packages";
import { SERVICES_TYPES, useInjection } from "@/ioc";
import { PlanSettings } from "@/models/package";
import { useToast } from "@/hooks/use-toast";

export const useUpdatePackage = () => {
  const packagesApi = useInjection<IPackagesApi>(SERVICES_TYPES.PACKAGES);
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({ key, settings }: { key: string; settings: PlanSettings }) =>
      packagesApi.updatePackage(key, settings),
    onSuccess: (pkg) => {
      queryClient.invalidateQueries({ queryKey: ["packages"] });
      toast({ title: `${pkg.name} saved` });
    },
    onError: (error) => {
      toast({
        title: "Failed to save package",
        description: error.message,
        variant: "destructive"
      });
    }
  });
};
